// extracted by mini-css-extract-plugin
export default {"info":"qG47tu","date":"VZY5mO","number":"A0w1Uj"};